import { memo } from 'react';

import { flexRender, type Row } from '@tanstack/react-table';
import type { VirtualItem } from '@tanstack/react-virtual';

import { TableCell, TableRow } from '../../Table';
import { getCommonPinningStyles } from '../utils';

interface RenderRowsProps<TData> {
  columnPinning: any;
  key: number | string;
  index: number;
  row: Row<TData>;
  selected?: boolean;
  virtualRow?: VirtualItem;
}

const DataTableRow = <TData,>({
  index,
  row,
  virtualRow,
  selected,
}: RenderRowsProps<TData>) => {
  const height = virtualRow ? `${virtualRow?.size}px` : 'auto';
  const transform = virtualRow
    ? `translateY(${virtualRow?.start - index * virtualRow?.size}px)`
    : undefined;
  let isEven = true;

  if (!virtualRow) {
    isEven = index % 2 === 0;
  }

  if (virtualRow) {
    isEven = virtualRow.index % 2 === 0;
  }

  return (
    <TableRow
      key={index + row.id}
      hover
      data-state={selected}
      isEven={isEven}
      style={{ height, transform }}
    >
      {row.getVisibleCells().map((cell) => {
        return (
          <TableCell
            key={cell.id}
            style={{ ...getCommonPinningStyles(cell.column) }}
          >
            {flexRender(cell.column.columnDef?.cell, cell.getContext())}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default memo(DataTableRow);
